export const SMS_STEP_TYPES = new Set(['send_sms', 'sms', 'sms_action']);

export function isSmsStep(step) {
  if (!step) return false;
  return SMS_STEP_TYPES.has(String(step.type || '').trim().toLowerCase());
}
